import Questionnaire from "../sections/Questionnaire";

const icons = [
  {
    title: "Sehr selten",
    // TODO eventuell beschreibung das es um Ferienzimmer geht
    externalLink: "/hebeanlage/kleinhebeanlage/",
    imgUrl: "/content/uploads/2018/08/haus.png",
    description: "Beispielsweise bei einem nur gelegentlich genutzem WC im Keller (Gäste-WC)."
  },
  {
    title: "Normal genutzt",
    link: "haeufig",
    imgUrl: "/content/uploads/2018/08/loch.png",
    description: "Mit normal ist ein WC gemeint, das im Zuge des Wohnens regelmäßig mit benutzt wird."
  }
]

export function AbwasserHaus() {

  return (
    <Questionnaire question={"Wie oft wird der Waschraum genutzt?"} icons={icons} />
  );
}